import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Admin Dashboard CRUD service.
 *
 * Mirrors the original AngularJS `adminDdashboardFactory` from
 * `GTW12/ui/app/components/admin/adminDashboards/adminDashboardService.js`,
 * which uses raw `$http.post` (not JsonObjectFactory.saveJSON) — see
 * ADMIN_TAB_MIGRATION_GUIDE.md, Pitfall M8.
 */
@Injectable({ providedIn: 'root' })
export class AdminDashboardsService {
  private static readonly URLS = {
    getDashboardByKey: '/getDashboardByKey',
    createDashboard: '/createDashboard',
    removeSheet: '/deleteSheet',
    removeFilter: '/deleteDashFilterByKey',
    removeComponent: '/deleteComponentByKey',
    mergeUnmergeComponent: '/mergeUnmergeComponent',
  };

  constructor(private http: HttpClient) {}

  getDashboardByKey(baseUrl: string, dashboardId: string | number): Observable<any> {
    const url = baseUrl + AdminDashboardsService.URLS.getDashboardByKey;
    return this.http.post<any>(url, { dashboard_id: dashboardId }, { withCredentials: true });
  }

  createDashboard(baseUrl: string, params: Record<string, any>): Observable<any> {
    const url = baseUrl + AdminDashboardsService.URLS.createDashboard;
    return this.http.post<any>(url, params, { withCredentials: true });
  }

  deleteSheet(baseUrl: string, params: { sheet_key: any; sheet_name: string }): Observable<any> {
    const url = baseUrl + AdminDashboardsService.URLS.removeSheet;
    return this.http.post<any>(url, params, { withCredentials: true });
  }

  deleteFilterByKey(baseUrl: string, params: { filter_name: string; dashboard_id: any }): Observable<any> {
    const url = baseUrl + AdminDashboardsService.URLS.removeFilter;
    return this.http.post<any>(url, params, { withCredentials: true });
  }

  deleteComponentByKey(baseUrl: string, params: { comp_key: any }): Observable<any> {
    const url = baseUrl + AdminDashboardsService.URLS.removeComponent;
    return this.http.post<any>(url, params, { withCredentials: true });
  }

  mergeUnmergeComponent(baseUrl: string, params: Record<string, any>): Observable<any> {
    const url = baseUrl + AdminDashboardsService.URLS.mergeUnmergeComponent;
    return this.http.post<any>(url, params, { withCredentials: true });
  }

  /**
   * Posts to a sheet's action_id URL to load underlying data so we can derive
   * the list of available "Filter By" predicates (column keys).
   * Equivalent to the original `adminDdashboardFactory.getActionData`.
   */
  getActionData(actionUrl: string, params: Record<string, any>): Observable<any> {
    return this.http.post<any>(actionUrl, params, { withCredentials: true });
  }
}
